import { RangePickerProps } from "antd/es/date-picker";
import dayjs from "dayjs";
import XmRangeDatePicker from "src/component/dataTimePicker/XmRangeDatePicker";

interface AuditDatePickerProps {
  isTimeSet: boolean;
  startDate: Date;
  endDate: Date;
  onChange: RangePickerProps['onChange'];
}

const AuditLogDatePicker = ({ isTimeSet, startDate, endDate, onChange }: AuditDatePickerProps) => {
  return (
    <div className="audit-time-range">
      <div className="audit-time-range-header">
        <div>Time range</div>
      </div>
      <XmRangeDatePicker
        className={!isTimeSet ? 'error-select' : ''}
        defaultValue={[dayjs(startDate), dayjs(endDate)]}
        onChange={onChange}
      />
    </div>
  );
};

export default AuditLogDatePicker;
